/*
 * サブシステム名：受注契約
 * 機能名：受注契約一覧画面
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdRadioButton from '@/components/DdRadioButton'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import DdTextBox from '../../components/DdTextBox.vue'
import DdIconButton from '../../components/DdIconButton.vue'
import DdYearMonthBox from '@/components/DdYearMonthBox.vue'

import DdJuchuListDialog from '@/components/DdJuchuListDialog'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import header from '@/ddv2.library/header'

export default {
  name: 'juchuKeiyakuList',
  mixins: [flowMixin],
  data: () => ({
    conditions: {
      keiyakuEndStartYm: '',
      keiyakuEndEndYm: '',
      juchuKeiyakuEigyoshoCd: '',
      insUserCd: '',
      seikyusakiCd: '',
      keiyakuNm: '',
      jidoKeizokuSbt: '9'
    },
    headersEigyoshoList: header.mstEigyoshoHeaders,
    // headersEigyoshoList: [
    //   { width: '60px', text: '営業所コード', value: 'eighoshoCd' },
    //   { width: '90px', text: '営業所名', value: 'eighoshoNm' }
    // ],
    headersJininList: header.mstJininHeaders,
    // headersJininList: [
    //   { width: '60px', text: '担当者コード', value: 'jininCd' },
    //   { width: '90px', text: '担当者名', value: 'jininNm' }
    // ],
    headersSeikyusakiList: header.mstTorihikisakiHeaders,
    // headersSeikyusakiList: [
    //   { width: '60px', text: '請求先コード', value: 'seikyusakiCd' },
    //   { width: '90px', text: '請求先名', value: 'seikyusakiNm' }
    // ],
    expansionPanel: [0, 1],
    juchuKeiyakuId: 0,
    juchuListDialog: false,
    page: 1
  }),
  components: {
    DdSubHeader,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdRadioButton,
    DdCodeTextBox,
    DdTextBox,
    DdIconButton,
    DdYearMonthBox,
    DdJuchuListDialog
  },
  computed: {
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.juchuKeiyakuYmdDisp = filter.dateFormatter(elem.juchuKeiyakuYmd)
        elem.keiyakuStartYmdDisp = filter.dateFormatter(elem.keiyakuStartYmd)
        elem.keiyakuEndYmdDisp = filter.dateFormatter(elem.keiyakuEndYmd)

        if (elem.keiyakuKihonKingaku === null || elem.keiyakuKihonKingaku === undefined) {
          elem.keiyakuKihonKingakuDisp = ''
        } else {
          elem.keiyakuKihonKingakuDisp = filter.numericFormatter(elem.keiyakuKihonKingaku)
        }
        if (elem.keiyakuKihonSuryo === null || elem.keiyakuKihonSuryo === undefined) {
          elem.keiyakuKihonSuryoDisp = ''
        } else {
          elem.keiyakuKihonSuryoDisp = filter.numericFormatter(elem.keiyakuKihonSuryo)
        }
        if (elem.suryoWarimashiTani === null || elem.suryoWarimashiTani === undefined) {
          elem.suryoWarimashiTaniDisp = ''
        } else {
          elem.suryoWarimashiTaniDisp = filter.numericFormatter(elem.suryoWarimashiTani)
        }
        if (elem.juryoWarimashiKingaku === null || elem.juryoWarimashiKingaku === undefined) {
          elem.juryoWarimashiKingakuDisp = ''
        } else {
          elem.juryoWarimashiKingakuDisp = filter.numericFormatter(elem.juryoWarimashiKingaku)
        }
        if (elem.keiyakuKihonKyori === null || elem.keiyakuKihonKyori === undefined) {
          elem.keiyakuKihonKyoriDisp = ''
        } else {
          elem.keiyakuKihonKyoriDisp = filter.numericFormatter(elem.keiyakuKihonKyori)
        }
        if (elem.juryoWarimashiTani === null || elem.juryoWarimashiTani === undefined) {
          elem.juryoWarimashiTaniDisp = ''
        } else {
          elem.juryoWarimashiTaniDisp = filter.numericFormatter(elem.juryoWarimashiTani)
        }
        if (elem.suryoWarimashiKingaku === null || elem.suryoWarimashiKingaku === undefined) {
          elem.suryoWarimashiKingakuDisp = ''
        } else {
          elem.suryoWarimashiKingakuDisp = filter.numericFormatter(elem.suryoWarimashiKingaku)
        }
        if (elem.keiyakuKihonJuryo === null || elem.keiyakuKihonJuryo === undefined) {
          elem.keiyakuKihonJuryoDisp = ''
        } else {
          elem.keiyakuKihonJuryoDisp = filter.numericFormatter(elem.keiyakuKihonJuryo)
        }
        if (elem.kyoriWarimashiTani === null || elem.kyoriWarimashiTani === undefined) {
          elem.kyoriWarimashiTaniDisp = ''
        } else {
          elem.kyoriWarimashiTaniDisp = filter.numericFormatter(elem.kyoriWarimashiTani)
        }
        if (elem.kyoriWarimashiKingaku === null || elem.kyoriWarimashiKingaku === undefined) {
          elem.kyoriWarimashiKingakuDisp = ''
        } else {
          elem.kyoriWarimashiKingakuDisp = filter.numericFormatter(elem.kyoriWarimashiKingaku)
        }

        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      jininList: 'DDMasters/mstJinin',
      seikyusakiList: 'DDMasters/mstSeikyusaki',
      torihikisakiList: 'DDMasters/vwCMstTorihikisakiGetSeikyusaki'
    }),
    filteredSeikyusakiList () {
      // 請求先で絞り込む
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'mstjinin', 'mstseikyusaki', 'vwcmsttorihikisakigetseikyusaki'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('JuchuKeiyakuList.defineHeaderPromise')
            self.headers = [
              { text: '操作', value: 'action' },
              { text: '受注契約番号', value: 'juchuKeiyakuNo' },
              { text: '受注契約日', value: 'juchuKeiyakuYmdDisp', align: 'center' },
              { text: '受注契約営業所', value: 'juchuKeiyakuEigyoshoNm' },
              { text: '請求先', value: 'seikyusakiNm' },
              { text: '客先契約番号', value: 'kyakusakiKeiyakuNo' },
              { text: '契約名', value: 'keiyakuNm' },
              { text: '契約満了日', value: 'keiyakuEndYmdDisp', align: 'center' },
              { text: '契約開始日', value: 'keiyakuStartYmdDisp', align: 'center' },
              { text: '契約期間', value: 'keiyakuKikanTsukisu' },
              { text: '契約基本金額', value: 'keiyakuKihonKingakuDisp', align: 'end' },
              { text: '請求計上単位区分', value: 'seikyuKeijoTaniKbnNm' },
              { text: '自動継続', value: 'jidoKeizokuFlgNm' },
              { text: '自動継続データ', value: 'jidoKeizokuData' },
              { text: '請求先担当者', value: 'seikyusakiTantosha' },
              { text: '請求先電話番号', value: 'seikyusakiTelNo' },
              { text: '請求先担当者メールアドレス', value: 'seikyusakiMailAddress' },
              { text: '契約備考', value: 'juchuKeiyakuBiko' },
              { text: '契約基本数量', value: 'keiyakuKihonSuryoDisp', align: 'end' },
              { text: '割増数量単位', value: 'suryoWarimashiTaniDisp', align: 'end' },
              { text: '数量割増金額', value: 'suryoWarimashiKingakuDisp', align: 'end' },
              { text: '契約基本重量', value: 'keiyakuKihonJuryoDisp', align: 'end' },
              { text: '割増重量単位', value: 'juryoWarimashiTaniDisp', align: 'end' },
              { text: '重量割増金額', value: 'juryoWarimashiKingakuDisp', align: 'end' },
              { text: '契約基本距離', value: 'keiyakuKihonKyoriDisp', align: 'end' },
              { text: '割増距離単位', value: 'kyoriWarimashiTaniDisp', align: 'end' },
              { text: '距離割増金額', value: 'kyoriWarimashiKingakuDisp', align: 'end' }]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise(resolve => {
            const thisYmString = `${new Date().getFullYear()}/${('0' + (new Date().getMonth() + 1)).slice(-2)}`
            self.conditions = {
              keiyakuEndStartYm: thisYmString,
              keiyakuEndEndYm: thisYmString,
              juchuKeiyakuEigyoshoCd: '',
              insUserCd: '',
              seikyusakiCd: '',
              keiyakuNm: '',
              jidoKeizokuSbt: '9'
            }
            self.juchuListDialog = false
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('juchuKeiyakuList.savedInputRestorePromise', c)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('juchuKeiyakuList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('juchuKeiyakuList.researchPromise', c)
          console.log('juchuKeiyakuList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.conditions || {}
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('juchuKeiyakuList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.conditions || {}
            self.searchText = c.cache.searchText || ''
            self.rows = c.cache.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('juchuKeiyakuList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        getCloneTargetMethod: function () {
          return {
            conditions: self.conditions
          }
        }
      }
      self.initializeForViewer(opt)
    },
    onJuchuListDialogOpen: function (item) {
      console.log('onJuchuListDialogOpen', item)
      this.juchuKeiyakuId = item.id
      this.juchuListDialog = true
    },
    onJuchuListDialoClose: function (e) {
      this.juchuListDialog = false
      console.log('onJuchuListDialogClose', e)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2orcd0010/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    // onSearchButtonClick: function (e) {
    //   this.Effects.loadStart()
    //   this.search().then(() => {
    //     console.log('this.search()', this.rows)
    //     this.Effects.loadComplete()
    //   })
    // },
    // search: function () {
    //   console.log('a', this.headers)
    //   return new Promise(resolve => {
    //     this.HttpClient
    //       .post('/api/v1/VwCD2orcd0010/search', this.conditions)
    //       .then((data) => {
    //         this.rows = data.payload

    //         const cache = {
    //           rows: this.rows,
    //           conditions: this.conditions,
    //           searchText: this.searchText
    //         }
    //         this.saveToChache(cache)
    //           .then(() => {
    //             resolve()
    //           })
    //       })
    //   })
    // },
    clear: function () {
      console.log('clear')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            const thisYmString = `${new Date().getFullYear()}/${('0' + (new Date().getMonth() + 1)).slice(-2)}`
            self.conditions = {
              keiyakuEndStartYm: thisYmString,
              keiyakuEndEndYm: thisYmString,
              juchuKeiyakuEigyoshoCd: '',
              insUserCd: '',
              seikyusakiCd: '',
              keiyakuNm: '',
              jidoKeizokuSbt: '9'
            }
            self.searchText = ''
            self.rows = []
            self.juchuListDialog = false
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowClick: function (e) {
      console.log('onRowClick', e)
      this.Effects.loadStart()

      this.transition(0, { id: e.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/VwCD2orcd0010/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    searchValidate: function () {
      return true
    }
  }
}
